<template>
    <div>
        <router-link class="btn btn-primary" to="/membership">{{$t('BACK_TO_MEMBERSHIP_ORDERS')}}</router-link>
        <form class="card p-4 shadow w-auto mt-4" id="membership-form" @submit.prevent="orderMembership">
            <h3 class="title">{{$t('ORDER_A_MEMBERSHIP')}}</h3>
            <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                :variant="response.success === true ? 'success' : 'danger'"
                @dismissed="dismissCountDown = 0"
                >
                {{response.message}}
            </b-alert>
            <div class="w-auto">
                <div class="input-group mb-3 w-auto">
                    <div class="input-group-prepend">
                        <span class="input-group-text" for="inputGroupSelectPeriod">{{$t('PERIOD')}}</span>
                    </div>
                    <select v-model.number="selectedPeriod" class="custom-select">
                        <option v-for="(periodItem,index) in periods" :key="index" id="inputGroupSelectPeriod" :selected='index == 0' :value="periodItem.value">
                            {{ periodItem.name + (periodItem.value !== 1 ? prices[periodItem.value] : '') }}
                        </option>
                    </select>
                </div>

                <button type="submit" class="btn btn-primary">{{$t('ORDER_A_MEMBERSHIP')}}</button>
            </div>
        </form>


    </div>
</template>
<script>export default {
        data() {
            return {
                selectedPeriod: 1,
                periods: [
                    {
                        name: "Unlimited",
                        value: 1
                    },
                ],
                response: {
                    success: null,
                    message: null
                },
                dismissCountDown: 0,
                prices: {}
            }
        },
        methods: {
            orderMembership() {
                let self = this;
                let isTrial = this.selectedPeriod == 1;
                this.$http.post("/api/membership/order", {
                    orderedMonths: self.selectedPeriod,
                    isTrial: isTrial
                })
                    .then(response => {
                        self.response.success = response.data.success;
                        self.response.message = response.data.information;
                        self.dismissCountDown = 3;
                        if (response.data.success === true && isTrial == false) {
                            this.$router.push({
                                path: '/membership/order/success',
                                query: {
                                    info: response.data.membershipInfo
                                }
                            });
                        } else if (response.data.success === true && isTrial == true) {
                            this.$router.push({
                                path: '/membership'
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        created: function () {
            this.$http
                .get('/api/membership/prices')
                .then(response => {
                    this.prices = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
</script>
<style lang="scss" scoped>
    #membership-form {
        max-width: 430px;

        .title {
            font-size: 20px;
            font-weight: bold;
        }
    }
</style>